import { AppstoreOutlined, LayoutOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import type { TablesView } from "../../../../../api/configuration";
import { SegmentedToggle } from "../../SegmentedToggle";
import { VoiceOrderButton } from "../voice/VoiceOrderButton";

/**
 * Горната лента на масите: Списък | Схема — СЪЩИЯТ превключвател като
 * Плочки | Таблица във футъра на продуктите, без клавиш (F7 тук е „Закрий").
 * В режим „Схема" до него е и микрофонът (там търсачката на списъка я няма).
 */
export const TablesViewSwitch = ({
  value,
  onChange,
  onVoiceOrder,
  voiceLocked,
}: {
  value: TablesView;
  onChange: (view: TablesView) => void;
  /** Само при право open_bill_voice и в режим „Схема". */
  onVoiceOrder?: () => void;
  voiceLocked: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <>
      <SegmentedToggle
        options={[
          {
            value: "list",
            icon: <AppstoreOutlined className="text-[15px]" />,
            label: t("ordering.tablesViewList"),
          },
          {
            value: "schema",
            icon: <LayoutOutlined className="text-[15px]" />,
            label: t("ordering.tablesViewSchema"),
          },
        ]}
        value={value}
        onChange={onChange}
        size="bar"
      />
      {onVoiceOrder && <VoiceOrderButton onClick={onVoiceOrder} locked={voiceLocked} small />}
    </>
  );
};
